import { useQuery } from '@tanstack/react-query';
import restClient from '../common/api/restClient';

export const useCoaches = ({ name, page, enabled = true }) => {
  const prefix = process.env.REACT_APP_PROXY_PREFIX || '';
  return useQuery({
    queryKey: ['coaches', { name, page }],
    queryFn: async () => {
      const result = await restClient({ 
        url: `${prefix}/coaches`, 
        method: 'post',
        data: {
          name,
          page
        }
      });
      return result;
    },
    enabled,
    staleTime: 0,
    cacheTime: 0, 
    refetchOnWindowFocus: false
  });
};
